import { Link } from "react-router-dom";
import { Phone, MapPin, Instagram } from "lucide-react";
import { WhatsAppIcon } from "../common/WhatsAppIcon";
import { NAV_LINKS, LOGO_FOOTER } from "../../data/site";
import { slugify } from "../../data/defaults";
import { useC, useSite, useWa } from "../../context/SiteData";

export const Footer = () => {
  const c = useC();
  const site = useSite();
  const wa = useWa();

  return (
    <footer data-testid="footer" className="bg-ink-900 text-cream-50">
      <div className="container-x grid gap-12 py-16 sm:py-20 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <img src={LOGO_FOOTER} alt="Yalı Yurt — Erkek Öğrenci Yurdu" className="h-16 w-auto sm:h-20" data-testid="footer-logo" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-cream-50/60">
            {c.footer_text}
          </p>
        </div>

        <div>
          <p className="label text-cream-50/40">Menü</p>
          <ul className="mt-5 space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${slugify(l.label)}`}
                  className="text-sm text-cream-50/70 transition-colors duration-300 hover:text-cream-50"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="label text-cream-50/40">İletişim</p>
          <ul className="mt-5 space-y-3.5 text-sm text-cream-50/70">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0" />
              <span>
                {site.address}
                <br />
                {site.addressCity}
              </span>
            </li>
            <li>
              <a href={site.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 transition-colors hover:text-cream-50">
                <Phone size={16} className="shrink-0" /> {site.phone}
              </a>
            </li>
            <li>
              <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 transition-colors hover:text-cream-50">
                <WhatsAppIcon size={16} className="shrink-0" /> WhatsApp Hattı
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="label text-cream-50/40">Takip Edin</p>
          <div className="mt-5 flex gap-3">
            <a
              href={site.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="footer-instagram"
              className="flex h-10 w-10 items-center justify-center border border-line-dark text-cream-50/70 transition-colors duration-300 hover:border-cream-50 hover:text-cream-50"
            >
              <Instagram size={17} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-line-dark">
        <div className="container-x flex flex-col items-start justify-between gap-4 py-6 text-xs text-cream-50/45 sm:flex-row sm:items-center">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} {site.fullName}. Tüm hakları saklıdır.
          </p>
          <p data-testid="footer-developer" className="text-cream-50/60">
            Tasarım & Yazılım:{" "}
            <a
              href="https://irvu.io"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-cream-50 transition-colors hover:text-cream-300"
            >
              irvu.io
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
